import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  whiteColor: {
    color: theme.palette.common.white,
    fontSize: 34,
    lineHeight: 1.3,
    fontWeight: 'bold',
  },
  carouselSection: {
    padding: theme.spacing(6, 0),
    background: 'linear-gradient(190deg, #DC1866 7%, #FF9226 108%)',
  },
  carouselRoot: {
    marginTop: theme.spacing(4),
    padding: 0,
  },
  carousel: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 14),
    },

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 35),
    },

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 46),
    },
  },
  carouselItem: {
    textAlign: 'center',
    padding: theme.spacing(0, 10),

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 1),
    },
  },
  carouselContent: {
    '& img': {
      display: 'block',
      maxWidth: '100%',
    },

    '& p': {
      padding: theme.spacing(2),
      opacity: 0,
      backgroundColor: '#F1B19F',
      transition: `opacity 250ms ${theme.transitions.easing.easeInOut}`,
    },

    '&:hover': {
      '& p': {
        opacity: 1,
      },
    },
  },
}));
